/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper from "swiper";
import { Navigation, EffectFade, Autoplay } from "swiper/modules";

export function slider() {
  const sliderSelector = ".cases-slider-wrapper";
  const init = function () {
    const sliders = [];
    const slidersElements = document.querySelectorAll(sliderSelector);
    if (slidersElements.length > 0) {
      slidersElements.forEach(slider => {
        // Check if slider is already initialized
        if (slider.swiper) {
          return;
        }

        // Count slides before initialization
        const slides = slider.querySelectorAll('.swiper-slide');
        const slideCount = slides.length;

        // If only one slide, handle differently
        if (slideCount <= 1) {
          // Hide navigation buttons
          const nextBtn = slider.querySelector('.swiper-button-next');
          const prevBtn = slider.querySelector('.swiper-button-prev');
          if (nextBtn) nextBtn.style.display = 'none';
          if (prevBtn) prevBtn.style.display = 'none';

          // Update pagination for single slide
          const offer = document.querySelector('.casesNumberSlides');
          if (offer) offer.style.display = 'none';
          return;
        }

        // For 2 slides, adjust breakpoints to prevent issues
        const breakpoints = slideCount === 2 ? {
          320: { slidesPerView: 1 },
          640: { slidesPerView: 1.5 },
          993: { slidesPerView: 1 },
          1100: { slidesPerView: 1.5 },
          1280: { slidesPerView: 2 },
          1441: { slidesPerView: 2 },
          1921: { slidesPerView: 2 }
        } : {
          320: { slidesPerView: 1.23 },
          640: { slidesPerView: 1.9 },
          993: { slidesPerView: 1.23 },
          1100: { slidesPerView: 1.53 },
          1280: { slidesPerView: 2.23 },
          1441: { slidesPerView: 2.78 },
          1921: { slidesPerView: slideCount === 3 ? 3 : 3.78 }
        };

        sliders.push(new Swiper(slider, {
          modules: [Navigation],
          speed: 500,
          slidesPerView: "auto",
          watchOverflow: true,
          allowTouchMove: slideCount > 1, // Disable touch if only one slide
          breakpoints: breakpoints,
          navigation: {
            nextEl: slider.querySelector('.swiper-button-next'),
            prevEl: slider.querySelector('.swiper-button-prev'),
          },
          on: {
            init(sw) {
              updatePaginationForCases(sw);
              toggleArrowVisibility(sw);
            },
            slideChange(sw) {
              updatePaginationForCases(sw);
              toggleArrowVisibility(sw);
            },
            reachEnd(sw) {
              updatePaginationForCases(sw);
              toggleArrowVisibility(sw);
            },
            reachBeginning(sw) {
              updatePaginationForCases(sw);
              toggleArrowVisibility(sw);
            },
            slideNextTransitionEnd(sw) {
              updatePaginationForCases(sw);
            },
            slidePrevTransitionEnd(sw) {
              updatePaginationForCases(sw);
            },
            transitionEnd(sw) {
              updatePaginationForCases(sw);
            },
            beforeResize(sw) {
              toggleArrowVisibility(sw);
            }
          },
        }));
      });
    }

    function updatePaginationForCases(sw) {
      const { isLocked, el } = sw;
      const offer = el.querySelector('.casesNumberSlides');
      if (!offer) return;
      offer.style.display = isLocked ? "none" : "block";

      // Safety check for slides
      if (!sw.slides || sw.slides.length === 0) return;

      // Get current slidesPerView
      const currentSlidesPerView = sw.params.slidesPerView === 'auto'
        ? sw.slidesPerViewDynamic()
        : sw.params.slidesPerView;

      const fullyVisibleSlides = Math.floor(currentSlidesPerView);

      // Check if we're at the end
      const nextBtn = sw.el.querySelector('.swiper-button-next');
      const isNextDisabled = nextBtn && nextBtn.classList.contains('swiper-button-disabled');
      const isSwiperAtEnd = sw.isEnd;

      // Check if we're at the beginning
      const prevBtn = sw.el.querySelector('.swiper-button-prev');
      const isPrevDisabled = prevBtn && prevBtn.classList.contains('swiper-button-disabled');
      const isSwiperAtBeginning = sw.isBeginning;

      console.log('Debug - activeIndex:', sw.activeIndex, 'isEnd:', isSwiperAtEnd, 'isNextDisabled:', isNextDisabled, 'isBeginning:', isSwiperAtBeginning, 'slidesLength:', sw.slides.length);

      let lastVisibleSlideIndex;

      if (isNextDisabled || isSwiperAtEnd) {
        // If at end, show total slides
        lastVisibleSlideIndex = sw.slides.length;
      } else if (isPrevDisabled || isSwiperAtBeginning) {
        // If at beginning, show based on visible slides from start
        lastVisibleSlideIndex = Math.min(fullyVisibleSlides, sw.slides.length);
      } else {
        // In the middle, calculate normally
        lastVisibleSlideIndex = Math.min(sw.activeIndex + fullyVisibleSlides, sw.slides.length);
      }

      // Update pagination display
      offer.innerHTML = lastVisibleSlideIndex + '/' + sw.slides.length;
    }

    function toggleArrowVisibility(swiperInstance) {
      const { isLocked, el, slides } = swiperInstance;
      const nextBtn = el.querySelector(".swiper-button-next");
      const prevBtn = el.querySelector(".swiper-button-prev");

      if (nextBtn && prevBtn) {
        // Hide arrows if locked OR if there's only one slide
        const shouldHide = isLocked || !slides || slides.length <= 1;
        const display = shouldHide ? "none" : "flex";
        nextBtn.style.display = display;
        prevBtn.style.display = display;
      }
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}

export function quoteSlider() {
  const sliderSelector = ".quote-slider-wrapper";

  const init = function () {
    const sliders = [];
    const slidersElements = document.querySelectorAll(sliderSelector);

    if (slidersElements.length > 0) {
      slidersElements.forEach(slider => {
        if (slider.swiper) return;

        const progressContainer = slider.querySelector(".segmented-progress-container");

        sliders.push(new Swiper(slider, {
          modules: [Navigation, EffectFade, Autoplay],
          slidesPerView: 1,
          slidesPerGroup: 1,
          watchOverflow: true,
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          speed: 500,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: slider.querySelector('.swiper-button-next'),
            prevEl: slider.querySelector('.swiper-button-prev'),
          },
          on: {
            init(sw) {
              // Hide progress bar if only one slide
              if (sw.slides.length <= 1) {
                progressContainer.style.display = "none";
              } else {
                generateProgressBars(sw);
                animateActiveBar(sw.activeIndex, sw.params.autoplay.delay);
              }
              toggleArrowVisibility(sw);
            },
            slideChange(sw) {
              if (sw.slides.length > 1) {
                animateActiveBar(sw.activeIndex, sw.params.autoplay.delay);
              }
              toggleArrowVisibility(sw);
            }
          }
        }));

        function generateProgressBars(sw) {
          const count = sw.slides.length;
          progressContainer.innerHTML = "";
          for (let i = 0; i < count; i++) {
            const bar = document.createElement("div");
            bar.className = "progress-bar inactive";
            const fill = document.createElement("div");
            fill.className = "progress-bar-fill";
            bar.appendChild(fill);
            progressContainer.appendChild(bar);
          }
        }

        function animateActiveBar(activeIndex, duration) {
          const bars = slider.querySelectorAll(".progress-bar");

          bars.forEach((bar, idx) => {
            const fill = bar.querySelector('.progress-bar-fill');
            bar.classList.remove("active");
            bar.classList.add("inactive");
            fill.style.transition = "none";
            fill.style.width = "0%";
          });

          const activeBar = bars[activeIndex];
          const activeFill = activeBar.querySelector(".progress-bar-fill");

          activeBar.classList.remove("inactive");
          activeBar.classList.add("active");

          // Animate fill
          setTimeout(() => {
            activeFill.style.transition = `width ${duration}ms linear`;
            activeFill.style.width = "100%";
          }, 50);
        }

        function toggleArrowVisibility(swiperInstance) {
          const { isLocked, el } = swiperInstance;
          const nextBtn = el.querySelector(".swiper-button-next");
          const prevBtn = el.querySelector(".swiper-button-prev");

          if (nextBtn && prevBtn) {
            const display = isLocked ? "none" : "flex";
            nextBtn.style.display = display;
            prevBtn.style.display = display;
          }
        }
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}

export function personSlider() {
  const sliderSelector = ".person-slider-wrapper";
  const init = function () {
    const sliders = [];
    const slidersElements = document.querySelectorAll(sliderSelector);
    if (slidersElements.length > 0) {
      slidersElements.forEach((slider) => {
        // Check if slider is already initialized
        if (slider.swiper) {
          return;
        }
        sliders.push(
          new Swiper(slider, {
            modules: [Navigation],
            speed: 500,
            slidesPerView: "auto",
            watchOverflow: false, // Disable default overflow detection
            breakpoints: {
              320: {
                slidesPerView: 1.201,
                spaceBetween: 16,
                slidesOffsetAfter: 30,
              },
              500: {
                slidesPerView: 1.5,
                spaceBetween: 16,
                slidesOffsetAfter: 30,
              },
              600: {
                slidesPerView: 1.9,
                spaceBetween: 16,
                slidesOffsetAfter: 30,
              },
              768: {
                slidesPerView: 2.201,
                spaceBetween: 20,
                slidesOffsetAfter: 30,
              },
              868: {
                slidesPerView: 2.5,
                spaceBetween: 20,
                slidesOffsetAfter: 30,
              },
              993: {
                slidesPerView: 3.201,
                spaceBetween: 20,
                slidesOffsetAfter: 100,
              },
              1280: {
                slidesPerView: 4.201,
                spaceBetween: 20,
                slidesOffsetAfter: 100,
              },
              1440: {
                slidesPerView: 4.2,
                spaceBetween: 20,
                slidesOffsetAfter: 100,
              },
              1921: {
                slidesPerView: 5.201,
                spaceBetween: 20,
                slidesOffsetAfter: 100,
              },
            },
            navigation: {
              nextEl: slider.querySelector(".swiper-button-next"),
              prevEl: slider.querySelector(".swiper-button-prev"),
            },
            on: {
              init(swiperInstance) {
                toggleArrowVisibility(swiperInstance);
              },
              slideChange(swiperInstance) {
                toggleArrowVisibility(swiperInstance);
              },
              resize(swiperInstance) {
                toggleArrowVisibility(swiperInstance);
              },
            },
          })
        );
      });
    }

    function toggleArrowVisibility(swiperInstance) {
      const { slides, el, params } = swiperInstance;
      const nextBtn = el.querySelector(".swiper-button-next");
      const prevBtn = el.querySelector(".swiper-button-prev");

      if (nextBtn && prevBtn) {
        // Simple check: if we have more slides than what's fully visible, show navigation
        const totalSlides = slides.length;
        const slidesPerView = params.slidesPerView;
        const fullyVisibleSlides = Math.floor(slidesPerView);

        // Show navigation if we have more slides than what fits fully visible
        // This accounts for the offset space by considering only fully visible slides
        const shouldShow = totalSlides > fullyVisibleSlides;
        const display = shouldShow ? "flex" : "none";

        nextBtn.style.display = display;
        prevBtn.style.display = display;
      }
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
}

export function contentBoxSlider() {
  const sliderSelector = ".content-box-slider-wrapper";
  const init = function () {
    const sliders = [];
    const slidersElements = document.querySelectorAll(sliderSelector);
    if (slidersElements.length > 0) {
      slidersElements.forEach((slider) => {
        // Check if slider is already initialized
        if (slider.swiper) {
          return;
        }
        sliders.push(
          new Swiper(slider, {
            modules: [Navigation],
            speed: 500,
            slidesPerView: "auto",
            watchOverflow: false, // Disable default overflow detection
            spaceBetween: 21,
            breakpoints: {
              320: {
                slidesPerView: 1.21,
                spaceBetween: 16,
                slidesOffsetAfter: 30,
              },
              640: {
                slidesPerView: 2.15,
                spaceBetween: 21,
                slidesOffsetAfter: 30,
              },
              1100: {
                slidesPerView: 2.1,
                slidesOffsetAfter: 100,
              },
              1280: {
                slidesPerView: 2.23,
                slidesOffsetAfter: 100,
              },
              1440: {
                slidesPerView: 3.17,
                slidesOffsetAfter: 100,
              },
              1921: {
                slidesPerView: 3.25,
                slidesOffsetAfter: 100,
              },
            },
            navigation: {
              nextEl: slider.querySelector(".swiper-button-next"),
              prevEl: slider.querySelector(".swiper-button-prev"),
            },
            on: {
              init(sw) {
                updatePaginationForContentBox(sw);
                toggleArrowVisibility(sw);
              },
              slideChange(sw) {
                updatePaginationForContentBox(sw);
                toggleArrowVisibility(sw);
              },
              resize(sw) {
                updatePaginationForContentBox(sw);
                toggleArrowVisibility(sw);
              },
            },
          })
        );
      });
    }

    function updatePaginationForContentBox(sw) {
      const { slides, el, params } = sw;
      // Select the pagination element inside the current slider container
      const offer = el.querySelector(".contentBoxNumberSlides");
      if (!offer) return;

      // Check if navigation should be shown using the same logic as toggleArrowVisibility
      const totalSlides = slides.length;
      const slidesPerView = params.slidesPerView;
      const fullyVisibleSlides = Math.floor(slidesPerView);
      const shouldShow = totalSlides > fullyVisibleSlides;

      offer.style.display = shouldShow ? "block" : "none";

      if (shouldShow) {
        // Get current slidesPerView (accounting for breakpoints)
        const currentSlidesPerView =
          sw.params.slidesPerView === "auto"
            ? sw.slidesPerViewDynamic()
            : sw.params.slidesPerView;
        // Calculate the last visible slide index
        const fullyVisibleSlidesCount = Math.floor(currentSlidesPerView);
        const lastVisibleSlideIndex = Math.min(
          sw.activeIndex + fullyVisibleSlidesCount,
          sw.slides.length
        );
        // Update pagination display
        offer.innerHTML = lastVisibleSlideIndex + "/" + sw.slides.length;
      }
    }

    function toggleArrowVisibility(swiperInstance) {
      const { slides, el, params } = swiperInstance;
      const nextBtn = el.querySelector(".swiper-button-next");
      const prevBtn = el.querySelector(".swiper-button-prev");

      if (nextBtn && prevBtn) {
        // Simple check: if we have more slides than what's fully visible, show navigation
        const totalSlides = slides.length;
        const slidesPerView = params.slidesPerView;
        const fullyVisibleSlides = Math.floor(slidesPerView);

        // Show navigation if we have more slides than what fits fully visible
        // This accounts for the offset space by considering only fully visible slides
        const shouldShow = totalSlides > fullyVisibleSlides;
        const display = shouldShow ? "flex" : "none";

        nextBtn.style.display = display;
        prevBtn.style.display = display;
      }
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
}

export function imageItemSlider() {
  const sliderSelector = ".image-slider-wrapper";

  const init = function () {
    const slidersElements = document.querySelectorAll(sliderSelector);

    if (slidersElements.length > 0) {
      slidersElements.forEach((slider) => {
        if (slider.swiper) return;

        const slides = slider.querySelectorAll(".swiper-slide");

        if (slides.length <= 1) {
          slider.classList.remove("swiper");
          slider.querySelector(".swiper-wrapper")?.classList.remove("swiper-wrapper");
          slides.forEach((slide) => slide.classList.remove("swiper-slide"));
          slider.querySelector(".swiper-button-next")?.remove();
          slider.querySelector(".swiper-button-prev")?.remove();
          slider.querySelector(".ImageNumberSlides")?.remove();
          return;
        }

        new Swiper(slider, {
          modules: [Navigation, EffectFade],
          speed: 500,
          slidesPerView: 1,
          slidesPerGroup: 1,
          effect: "fade",
          watchOverflow: true,
          loop: true,
          navigation: {
            nextEl: slider.querySelector(".swiper-button-next"),
            prevEl: slider.querySelector(".swiper-button-prev"),
          },
          on: {
            init(sw) {
              updateImagePagination(sw);
              toggleArrowVisibility(sw);
            },
            slideChange(sw) {
              updateImagePagination(sw);
              toggleArrowVisibility(sw);
            },
          },
        });
      });
    }

    function updateImagePagination(sw) {
      const offer = sw.el.querySelector(".ImageNumberSlides"); // scoped to slider
      if (!offer) return;

      const realSlidesCount = sw.slides.filter(
        (slide) => !slide.classList.contains("swiper-slide-duplicate")
      ).length;

      offer.innerHTML = `${sw.realIndex + 1}/${realSlidesCount}`;
    }

    function toggleArrowVisibility(swiperInstance) {
      const { isLocked, el } = swiperInstance;
      const nextBtn = el.querySelector(".swiper-button-next");
      const prevBtn = el.querySelector(".swiper-button-prev");

      if (nextBtn && prevBtn) {
        const display = isLocked ? "none" : "flex";
        nextBtn.style.display = display;
        prevBtn.style.display = display;
      }
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
}

export function logoSlider() {
  const sliderSelector = ".logo-slider-wrapper";

  const init = function () {
    const slidersElements = document.querySelectorAll(sliderSelector);

    if (slidersElements.length > 0) {
      slidersElements.forEach((slider) => {
        // Prevent re-initialization
        if (slider.classList.contains("swiper-initialized")) return;

        const wrapper = slider.querySelector(".swiper-wrapper");
        let originalSlides = wrapper.querySelectorAll(".swiper-slide");

        if (originalSlides.length > 0 && originalSlides.length < 100) {
          const cloneCount = 100 - originalSlides.length;
          for (let i = 0; i < cloneCount; i++) {
            const clone =
              originalSlides[i % originalSlides.length].cloneNode(true);
            wrapper.appendChild(clone);
          }

          // Re-query after cloning
          originalSlides = wrapper.querySelectorAll(".swiper-slide");
        }

        // Mark as initialized
        slider.classList.add("swiper-initialized");

        // Init Swiper with Autoplay + Loop
        new Swiper(slider, {
          modules: [Autoplay],
          speed: 3000,
          loop: true,
          loopedSlides: originalSlides.length,
          loopAdditionalSlides: originalSlides.length * 2, // extra clones buffer
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          },
          allowTouchMove: false,
          freeMode: true,
          className: "linear-swiper-slider",
          breakpoints: {
            320: {
              slidesPerView: 3.85,
              spaceBetween: 130,
              initialSlide: 1,
            },
            425: {
              slidesPerView: 3.85,
              spaceBetween: 140,
            },
            768: {
              slidesPerView: 2.7,
              spaceBetween: 15,
            },
            1024: {
              slidesPerView: 3.7,
              spaceBetween: 17,
            },
            1200: {
              slidesPerView: 4.2,
              spaceBetween: 17,
            },
            1400: {
              slidesPerView: 5.2,
              spaceBetween: 17,
            },
            1500: {
              slidesPerView: 5.5,
              spaceBetween: 17,
            },
            1700: {
              slidesPerView: 6.1,
              spaceBetween: 17,
            },
          },
        });
      });
    }
  };

  // Init on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
}

export function latestArticleSlider() {
  const sliderSelector = ".latest-article-slider";

  const init = function () {
    if (window.innerWidth >= 667) return;

    const slidersElements = document.querySelectorAll(sliderSelector);

    slidersElements.forEach((slider) => {
      if (slider.swiper) return;

      new Swiper(slider, {
        modules: [Navigation],
        speed: 500,
        slidesPerView: 1.14,
        spaceBetween: 20,
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("resize", () => {
    document.querySelectorAll(sliderSelector).forEach((slider) => {
      if (window.innerWidth < 667 && !slider.swiper) {
        new Swiper(slider, {
          modules: [Navigation],
          speed: 500,
          slidesPerView: 1.14,
          spaceBetween: 20,
        });
      } else if (window.innerWidth >= 667 && slider.swiper) {
        slider.swiper.destroy(true, true);
      }
    });
  });
}

export function imagesSlider() {
  const sliderSelector = ".images-slider-wrapper";
  const init = function () {
    const slidersElements = document.querySelectorAll(sliderSelector);

    if (slidersElements.length > 0) {
      slidersElements.forEach((slider) => {
        // Prevent re-initialization
        if (slider.classList.contains("swiper-initialized")) return;

        const wrapper = slider.querySelector(".swiper-wrapper");
        let originalSlides = wrapper.querySelectorAll(".swiper-slide");

        // Clone slides if less than 8 to enable loop mode properly
        if (originalSlides.length > 0 && originalSlides.length < 100) {
          const cloneCount = 100 - originalSlides.length;
          for (let i = 0; i < cloneCount; i++) {
            const clone =
              originalSlides[i % originalSlides.length].cloneNode(true);
            wrapper.appendChild(clone);
          }

          // Re-query after cloning
          originalSlides = wrapper.querySelectorAll(".swiper-slide");
        }

        // Mark as initialized
        slider.classList.add("swiper-initialized");

        // ✅ FIXED CONFIG
        new Swiper(slider, {
          modules: [Autoplay],
          speed: 5000,
          loop: true,
          loopedSlides: originalSlides.length,
          loopAdditionalSlides: originalSlides.length * 2, // extra clones buffer
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          },
          allowTouchMove: false,
          freeMode: true,
          breakpoints: {
            320: {
              slidesPerView: 1.268,
              spaceBetween: 8,
              initialSlide: 1,
            },
            425: {
              slidesPerView: 1.73,
              spaceBetween: 8,
              initialSlide: 1,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 12,
            },
            1024: {
              slidesPerView: 3.5,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 3.5,
              spaceBetween: 20,
            },
            1600: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          },
        });
      });
    }
  };

  // Init on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
}

export function locationSlider() {
  const sliderSelector = ".location-list-slider";
  const init = function () {
    const sliders = [];
    const slidersElements = document.querySelectorAll(sliderSelector);
    if (slidersElements.length > 0) {
      slidersElements.forEach((slider) => {
        // Check if slider is already initialized
        if (slider.swiper) {
          return;
        }
        sliders.push(
          new Swiper(slider, {
            modules: [Navigation],
            speed: 500,
            slidesPerView: "auto",
            watchOverflow: false, // Disable default overflow detection
            breakpoints: {
              320: {
                slidesPerView: 1.145,
                spaceBetween: 16,
                slidesOffsetAfter: 30,
              },
              500: {
                slidesPerView: 1.5,
                spaceBetween: 16,
                slidesOffsetAfter: 30,
              },
              600: {
                slidesPerView: 1.9,
                spaceBetween: 16,
                slidesOffsetAfter: 30,
              },
              768: {
                slidesPerView: 2.201,
                spaceBetween: 20,
                slidesOffsetAfter: 30,
              },
              868: {
                slidesPerView: 2.5,
                spaceBetween: 20,
                slidesOffsetAfter: 30,
              },
              993: {
                slidesPerView: 3.201,
                spaceBetween: 20,
                slidesOffsetAfter: 100,
              },
              1280: {
                slidesPerView: 3.201,
                spaceBetween: 20,
                slidesOffsetAfter: 100,
              },
              1440: {
                slidesPerView: 3.15,
                spaceBetween: 20,
                slidesOffsetAfter: 100,
              },
              1921: {
                slidesPerView: 4.20,
                spaceBetween: 20,
                slidesOffsetAfter: 100,
              },
            },
            navigation: {
              nextEl: slider.querySelector(".swiper-button-next"),
              prevEl: slider.querySelector(".swiper-button-prev"),
            },
            on: {
              init(sw) {
                updatePaginationForLocation(sw);
                toggleArrowVisibility(sw);
              },
              slideChange(sw) {
                updatePaginationForLocation(sw);
                toggleArrowVisibility(sw);
              },
              resize(sw) {
                updatePaginationForLocation(sw);
                toggleArrowVisibility(sw);
              },
            },
          })
        );
      });
    }

    function updatePaginationForLocation(sw) {
      const { slides, el, params } = sw;
      const offer = el.querySelector('.locationNumberSlides');
      if (!offer) return;

      // Check if navigation should be shown using the same logic as toggleArrowVisibility
      const totalSlides = slides.length;
      const slidesPerView = params.slidesPerView;
      const fullyVisibleSlides = Math.floor(slidesPerView);
      const shouldShow = totalSlides > fullyVisibleSlides;

      offer.style.display = shouldShow ? "block" : "none";

      if (shouldShow) {
        // Get current slidesPerView (accounting for breakpoints)
        const currentSlidesPerView = sw.params.slidesPerView === 'auto'
          ? sw.slidesPerViewDynamic()
          : sw.params.slidesPerView;
        // Calculate the last visible slide index
        const fullyVisibleSlidesCount = Math.floor(currentSlidesPerView);
        const lastVisibleSlideIndex = Math.min(
          sw.activeIndex + fullyVisibleSlidesCount,
          sw.slides.length
        );
        // Update pagination display
        offer.innerHTML = lastVisibleSlideIndex + '/' + sw.slides.length;
      }
    }

    function toggleArrowVisibility(swiperInstance) {
      const { slides, el, params } = swiperInstance;
      const nextBtn = el.querySelector(".swiper-button-next");
      const prevBtn = el.querySelector(".swiper-button-prev");

      if (nextBtn && prevBtn) {
        // Simple check: if we have more slides than what's fully visible, show navigation
        const totalSlides = slides.length;
        const slidesPerView = params.slidesPerView;
        const fullyVisibleSlides = Math.floor(slidesPerView);

        // Show navigation if we have more slides than what fits fully visible
        // This accounts for the offset space by considering only fully visible slides
        const shouldShow = totalSlides > fullyVisibleSlides;
        const display = shouldShow ? "flex" : "none";

        nextBtn.style.display = display;
        prevBtn.style.display = display;
      }
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
}

// Auto-initialize
slider();
quoteSlider();
personSlider();
contentBoxSlider();
imageItemSlider();
logoSlider();
latestArticleSlider();
imagesSlider();
locationSlider();
